import React, { ButtonHTMLAttributes, ReactNode } from 'react';

interface ButtonSecondaryProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    children?: ReactNode;
}


const ButtonSecondary = (props: ButtonSecondaryProps) => {
    const { children, ...nativeProps } = props;
    return (
        <>
            <button className='btn btn-icon btn-secondary text-center justify-center' {...nativeProps}>{children}</button>
        </>
    );
};

export default ButtonSecondary;